import React, { useEffect, useState } from 'react'
import './TheatreHall.css'
import screen from '../../Resources/screen.jpg'
import {Link, useNavigate, useSearchParams} from 'react-router-dom'
import axios from 'axios'
import loadgif from '../../Resources/loading2.gif'
import BASE_URL from '../../constant'



function TheatreHall() {

    const [rows, setRows] = useState(0);
    const [columns, setCols] = useState(0);
    let alphaArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I','J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
    let rowArr = Array.from({length: rows}, (_, i) => i + 1);
    let colArr = Array.from({length: columns}, (_, i) => i + 1);



    const current = new Date();
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const date = `${current.getDate()}`
    const month = `${monthArr[current.getMonth()]}`


    const [totalSeats , setTotalSeats] = useState(0);
    const [msg, setMsg] = useState("");
    const seatLimit = 5;
    const msgstyle={
        top : (msg !== "") ? "15%" : "-10%"
    }
    const [price, setPrice] = useState(0);
    const [selectedSeatsArr, setSelectedSeatArr] = useState([]);
    const [searchParams] = useSearchParams(); 

    const movieId = searchParams.get("movieId");
    const showTimeId = searchParams.get("showTimeId");
    const theatreId = searchParams.get("theatreId");

    const [movieData, setMovieData] = useState({})
    const [theatreData, setTheatreData] = useState({});
    const [showsTimeList, setShowTimeList] = useState([]);
    const [bookedSeatsArr, setBookedSeatsArr] = useState([]);

    const [movieTime, setMovieTime] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    

    const handleCheckClick = (event, row, col)=>{

        if(event.target.checked){
            if(totalSeats >= seatLimit){
                setMsg(`Maximum ${seatLimit} seats are allowed only :|`);
                setTimeout(() => {
                    setMsg("");
                }, 3000);
                event.target.checked = false;
                return;
            }
            let seatNo = String(alphaArr[row-1]) + String(col);
            selectedSeatsArr.push(seatNo);
            setTotalSeats(prev => prev+1)
            if(row <= 3 ){
                (event.target.checked) ? setPrice(price+150)  : setPrice(price-150)
            }
            if(row > 3 && row <= 7 ){
                (event.target.checked) ? setPrice(price+250)  : setPrice(price-250)
            }
            if(row > 7 && row <= 10 ){
                (event.target.checked) ? setPrice(price+350)  : setPrice(price-350)
            }    

        }else if(!event.target.checked){
            if(totalSeats <= seatLimit){
                if(row <= 3 ){
                    (event.target.checked) ? setPrice(price+150)  : setPrice(price-150)
                }
                if(row > 3 && row <= 7 ){
                    (event.target.checked) ? setPrice(price+250)  : setPrice(price-250)
                }
                if(row > 7 && row <= 10 ){
                    (event.target.checked) ? setPrice(price+350)  : setPrice(price-350)
                }    
                setTotalSeats(prev => prev-1)

                let seatNo = String(alphaArr[row-1]) + String(col);
                let tempArr = [...selectedSeatsArr];
                if(tempArr.includes(seatNo)){
                    let index = tempArr.indexOf(seatNo);
                    tempArr.splice(index,1);
                }
                setSelectedSeatArr([...tempArr]);

                event.target.checked = false;
                return;
            }
        }
        
    }

    useEffect(()=>{

        axios.get(`${BASE_URL}/bookmyshow/api/v1/movie/${movieId}`)
        .then(res => {
            setMovieData(res.data);
            setLoading(false);
        })
        .catch(err => {console.error(err);
        setMessage("Unable to fetch theatre information. Try again later."); setLoading(false)});

        axios(`${BASE_URL}/bookmyshow/api/v1/theatre/${theatreId}`)
        .then(res => {
            setTheatreData(res.data);
            setRows(res.data.seatArrangement.rows)
            setCols(res.data.seatArrangement.cols)
            setLoading(false);
        })
        .catch(err => {console.error(err);
            setMessage("Unable to fetch theatre information. Try again later."); setLoading(false)});


        axios.get(`${BASE_URL}/bookmyshow/api/v1/shows/show-time/${showTimeId}?theatreId=${theatreId}&movieId=${movieId}`)
        .then(res => {
            setShowTimeList(res.data.shows);
            res.data.shows.forEach((time)=>{
                if(time._id === showTimeId){
                    setMovieTime(time.showTime);
                    setBookedSeatsArr(time.bookedSeats);
                    setLoading(false);
                }
            })
        })
        .catch(err => {console.error(err);
        setMessage("Unable to fetch theatre information. Try again later."); setLoading(false)});
    },[movieId, showTimeId, theatreId])

    const navigate = useNavigate();
    const handleBookTickets = ()=>{
        navigate(`/payment`,{state: 
            {
                seatsArr : selectedSeatsArr,
                seatPrice : price,
                theatreId,
                movieId,
                movieTime,
                showTimeId,
                date : date+month
            }
        })
    }
    const handleTime = (time, theatre, movie)=>{
        setRows(0);
        setCols(0);
        setTotalSeats(0); setPrice(0); setSelectedSeatArr([]);
        navigate(`/book-tickets?showTimeId=${time}&theatreId=${theatre}&movieId=${movie}`);
    }

    return (
        <>
        <div className="message" style={msgstyle}>
            <i className='fa-solid fa-info-circle'></i>&nbsp; {msg}
        </div>
        <div className="hallHeader fxcn">
            <div className="hallLeft fxcn">
                <div className="backIcon">
                    <Link to={'/theatre-list/' + movieData._id} 
                    className='alink'>
                        <i className='fa-solid fa-arrow-left'></i>
                    </Link>
                </div>
                <div className="nameAndInfo">
                    <div className="movieName">{movieData.name}</div>
                    <div className="ticket-summary fxcn">
                        <div className="theatreName">{theatreData.name}</div> |&nbsp;
                        <div className="ticket-date">Today, {date} {month}</div> |&nbsp;
                        <div className="movie-time">{movieTime}</div>
                    </div>
                </div>
            </div>
            {(totalSeats > 0) && 
            <div className="seatandticket fxcn">
                <div className="seatnocont fxcn">
                    <i className='fa-solid fa-chair'></i>{
                    selectedSeatsArr.map((seat,i)=>{
                        return <div key={i} className="seatno">{seat}</div>
                    })
                }</div>
                <div className="noOfTickets">
                    {totalSeats} Tickets
                </div>
            </div>
            }
        </div>
        <div className="showTimeheader fxcn">
            <div className="showTiming fxcn">
                {
                    showsTimeList && showsTimeList.map((time,i)=>{
                        return <div key={i}>
                            {
                            (time._id === showTimeId) ? 
                            <div  className="time" style={{backgroundColor : "#6cc55b", color : "#fff"}}>{time.showTime}</div> :
                            <div  className="time" 
                            onClick={()=>{handleTime(time._id, theatreId, movieData._id)}} >{time.showTime}</div>
                            }
                        </div>
                    })
                }
            </div>
            <div className="boxInfoCont fxcn">
                <div className="inBoxInfo fxcn">
                    <div className="disabled-box fxcn" style={{width : "20px", height: "20px"}}>
                        <i className='fa-solid fa-user'></i>
                    </div>
                    <span>Occupied</span>
                </div>
                <div className="inBoxInfo fxcn">
                    <div className="inbox">
                      
                    </div>
                    <span>Available</span>
                </div>
            </div>
        </div>
        <div className="error-message">{message}</div>
        {(loading) ? <div className='gifContainer'>
        <img src={loadgif} alt="Loading..." /><div>Loading theatre details...</div>
        </div> : 
        <div className="theatre-system fxcn">
            <div className="screen">
                <div className="screeninfo">All eyes this way please!</div>
                <img src={screen} alt="" />
            </div>
            <div className="seatContainer">
                {
                    rowArr.map((num, ind)=>{
                        let rowBtmStyle = {
                            marginBottom : (num === 3 || num ===7)?"30px" : "5px"
                        }
                        return (
                            <div key={ind} className="boxRow fxcn" style={rowBtmStyle}>
                                {(num===1 || num===4 || num=== 8)&&
                                <div className="seatPrice">
                                    { (num===1) && `Executive : ₹ 150` }
                                    { (num===4) && `Club : ₹ 250` }
                                    { (num===8) && `Prime : ₹ 350` }
                                </div> }
                                <div className="alphbox box fxcn">{alphaArr[num-1]}</div>
                                {
                                    colArr.map((cnum , cind)=>{
                                        return (
                                            <div key={cind} className="customCheck"  
                                            style={{"marginRight" : (cnum === 4 || cnum === 16)? "80px" : "0px"}} >
                                                {(num === 1) && <div className="seatNum">{cnum}</div>}
                                                {
                                                (bookedSeatsArr.includes(alphaArr[num-1]+cnum)) ? 
                                                <div className="disabled-box fxcn bookedbox" >
                                                    <i className='fa-solid fa-user'></i>
                                                </div> : 
                                                <input key={cind} type="checkbox" 
                                                onClick={(event)=>{handleCheckClick(event, num, cnum)}}
                                                value={cnum} className='box' />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>}
        <div className="scrollmsg">Scroll to see full theatre hall &nbsp;
        <i className="fa-solid fa-hand-point-right"></i>
        </div>
        {
            (totalSeats > 0) ? 
        <div className="payBtnCont fxcn">
            <button className="bookBtn" onClick={handleBookTickets}>
                Book {totalSeats} Tickets for ₹ {price}
            </button>
        </div>: ""
        }
        </>
    )
}

export default TheatreHall
